export default "__VITE_ASSET__DwbNZonB__"